import { render } from "./ItemPicker.vue?vue&type=template&id=b81685fe"
import script from "./ItemPicker.vue?vue&type=script&lang=js"
export * from "./ItemPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__